<template>
  <div
    v-if="timeLogged || materialCost"
    class="flex flex-col gap-3 p-4 border-t border-secondary text-style-base font-medium lg:text-style-sm lg:text-secondary"
  >
    <div class="flex flex-row gap-2 items-center justify-start">
      <Icon name="clock-add" class="fg-quaternary" />
      <span class="flex-1">
        {{ $t("components.task_details.properties.logged_time.label") }}
      </span>
      <div class="flex gap-1">
        <Badge
          :label="formatDuration(timeLogged)"
          type="light"
          color="blue-light"
          :size="maxTablet ? 'lg' : 'md'"
          class="cursor-pointer"
          @click="$emit('showTimeLog')"
        />
        <Badge
          v-if="canLogTime"
          type="modern"
          border="dashed"
          :size="maxTablet ? 'lg' : 'md'"
          icon="only"
          class="cursor-pointer"
          @click="$emit('logTime')"
        >
          <Icon name="plus" size="xs" />
        </Badge>
      </div>
    </div>
    <div class="flex flex-row gap-2 items-center justify-start">
      <Icon name="euro-circle" class="fg-quaternary" />
      <span class="flex-1">
        {{ $t("components.task_details.properties.logged_material.label") }}
      </span>
      <div class="flex gap-1">
        <Badge
          :label="formatCurrency(materialCost)"
          type="modern"
          :size="maxTablet ? 'lg' : 'md'"
          class="cursor-pointer"
          @click="$emit('showMaterialLog')"
        />
        <Badge
          v-if="canLogMaterial"
          type="modern"
          border="dashed"
          :size="maxTablet ? 'lg' : 'md'"
          icon="only"
          class="cursor-pointer"
          @click="$emit('logMaterial')"
        >
          <Icon name="plus" size="xs" />
        </Badge>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Badge } from "@/SharedComponents/Badges";
import { Icon } from "@/SharedComponents/Icon";
import { useTask } from "@/Composables/useTask";
import { useDuration } from "@/Composables/useDuration";
import { useMonetary } from "@/Composables/useMonetary";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();

defineEmits(["logTime", "showTimeLog", "logMaterial", "showMaterialLog"]);

const props = defineProps({
  task: { type: Object, required: true },
  canLogTime: { type: Boolean, default: false },
  canLogMaterial: { type: Boolean, default: false },
});

const { formatDuration } = useDuration();
const { formatCurrency } = useMonetary();

const { getTimeLogged, getMaterialCost } = useTask(props.task);

const timeLogged = computed(() => {
  return getTimeLogged(props.task);
});

const materialCost = computed(() => {
  return getMaterialCost(props.task);
});
</script>
